export default "__VITE_ASSET__Bhcq81ST__"